import React, { useState } from 'react'
import {Dropdown, Header, Modal} from 'semantic-ui-react'
import SocialButtons from './SocialButtons'
import { Input, TextArea } from 'semantic-ui-react'
import GoogleShareToClassRoom from "google-classroom-share";
function Share(props) {
  const [copied, setCopied] = useState(false);
    const [gcType, setGCType] = useState("material");
    const exampleImage = props.circuit.thumbnail_url;
    const shareUrl = props.circuit.share_url;
    const title = props.circuit.lab_title;

  const onCopy = (event, data) =>{
     setCopied(true)
     const textField = document.createElement('textarea');
     textField.innerText = props.circuit.iframe_code;
     document.body.appendChild(textField);
     textField.select();
     document.execCommand('copy');
     textField.remove();
}


  return (
    <Modal
      closeIcon
      open={props.opened}
      onClose={() => {setCopied(false); props.setShareOpen(false)}}
      onOpen={() => props.setShareOpen(true)}
    >
      <Header icon='info' content="Make sure circuit is publicly accessible before sharing" color='blue'/>
      <Header icon='share' content={l.share_circuit} />
       <Modal.Content>
        <SocialButtons circuit={props.circuit}/>
      </Modal.Content>

        <Header icon='share' content={l.gc_share_button} />
        <Modal.Content>
<div>
            <div style={{display: 'inline-block'}} >
            <GoogleShareToClassRoom
                body="DCACLab"
                itemType={gcType}
                url={shareUrl}
                size={40}
                title={title}
                theme="classic"
                onShare={(type) => {
                    if (typeof gtag === "function")
                        gtag('event', "GoogleShareToClassRoom", {'event_category': "share", 'event_label': gcType });
                    }
                }
                onShareComplete={() =>{
                    if (typeof gtag === "function")
                        gtag('event', "GoogleShareCompleted", {'event_category': "share", 'event_label': gcType });
                    }
                }
                onShareStart={() => {
                    if (typeof gtag === "function")
                        gtag('event', "GoogleShareStart", {'event_category': "share", 'event_label': gcType });
                    }
                }
            />
            </div>
            <Dropdown
                style={{display: 'flex', bottom: 33, left: 50}}
                inline
                onChange= {(e, data) => setGCType(data.value)}
                header={l.gc_type}
                options={[{
                    key: 'gc0',
                    text: 'Announcement',
                    value: 'announcement',
                    content: 'Announcement',
                },{
                    key: 'gc1',
                    text: 'Assignment',
                    value: 'assignment',
                    content: 'Assignment',
                },{
                    key: 'gc2',
                    text: 'Material',
                    value: 'material',
                    content: 'Material',
                },
                {
                    key: 'gc3',
                    text: 'Question',
                    value: 'question',
                    content: 'Question',
                }]}
                defaultValue={gcType}
            />
            </div>
        </Modal.Content>

        {action_name != "lab" &&
            <>
      <Header icon='code' content={l.embed_circuit} />
      <Modal.Content>

        <Input
            fluid
            id="iframe_share"
            label={l.circuit_code}
            action={{ disabled: false ,onClick: onCopy, color: 'green', labelPosition: 'right', icon: 'copy', content: copied ? 'Copied!' : 'Copy' }}
            value={props.circuit.iframe_code}
          />

      </Modal.Content>
            </>
        }
    </Modal>
  )
}

export default Share
